import React from "react";
import { Container } from "react-bootstrap";
import webBanner from "../public/images/page_banner/gallery_desk.jpg";
import mobBanner from "../public/images/page_banner/gallery_mob.jpg";
import Image from "next/image";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Gallery = ({ data }) => {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
    Hash: false,
    Thumbs: false,
  });
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />

      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />

            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <Container>
          <div className="residency-wrapper gallery-wrapper text-center">
            <figure className="residency-box gallery-box">
              <a
                className="gallary-img ganga_aarti"
                htmlFor="Amphitheater"
                href="/images/prayag_completion/Ampi.jpg"
                data-fancybox="prayag-completion"
                data-caption="Amphitheater"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/badminton court.jpg"
                data-fancybox="prayag-completion"
                data-caption="Badminton Court"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/childrens play area.jpg"
                data-fancybox="prayag-completion"
                data-caption="Children Play Area"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/club house entrance.jpg"
                data-fancybox="prayag-completion"
                data-caption="Club House Entrance"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/club house reseption.jpg"
                data-fancybox="prayag-completion"
                data-caption="Club House Reseption"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/club house reseption1.jpg"
                data-fancybox="prayag-completion"
                data-caption="Club House Reseption"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/Gym.jpg"
                data-fancybox="prayag-completion"
                data-caption="Gym"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/indoor games 2.jpg"
                data-fancybox="prayag-completion"
                data-caption="Indoor Games"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/Indoor Games Room .jpg"
                data-fancybox="prayag-completion"
                data-caption="Indoor Games Room"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/indoor games3.jpg"
                data-fancybox="prayag-completion"
                data-caption="Indoor Games"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/internal road.jpg"
                data-fancybox="prayag-completion"
                data-caption="Internal Road"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/internal way.jpg"
                data-fancybox="prayag-completion"
                data-caption="Internal Way"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/jim.jpg"
                data-fancybox="prayag-completion"
                data-caption="Jim"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/kids play area.jpg"
                data-fancybox="prayag-completion"
                data-caption="Kids Play Area"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/Landscaped Podium.jpg"
                data-fancybox="prayag-completion"
                data-caption="Landscaped Podium"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/Library room.jpg"
                data-fancybox="prayag-completion"
                data-caption="Library Room"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/podium 2.jpg"
                data-fancybox="prayag-completion"
                data-caption="Podium"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/podium.jpg"
                data-fancybox="prayag-completion"
                data-caption="Podium"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/toddlers.jpg"
                data-fancybox="prayag-completion"
                data-caption="Toddlers"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/view of ganges.jpg"
                data-fancybox="prayag-completion"
                data-caption="View of Ganges"
              ></a>
              <a
                className="gallary-img"
                href="/images/prayag_completion/Yoga and Aerobics.jpg"
                data-fancybox="prayag-completion"
                data-caption="Yoga and Aerobics"
              ></a>
              <div className="residency-img">
                <span className="plus-icon">
                  <a
                    className="gallary-img"
                    href="/images/prayag_completion/Ampi.jpg"
                    data-fancybox="prayag-completion"
                    data-caption="Amphitheater"
                  >
                    <Image
                      fill
                      className="image"
                      alt="plus img"
                      src="/images/zoom_icon.png"
                    />
                  </a>
                </span>
                <a
                  className="gallary-img gall_wrp"
                  href="/images/prayag_completion/badminton court.jpg"
                  data-fancybox="prayag-completion"
                  data-caption="Badminton Court"
                >
                  <Image
                    fill
                    className="image img_overlay"
                    alt="Prayag Completion"
                    src="/images/prayag_completion/badminton court.jpg"
                    data-caption="Badminton Court"
                  />
                  <div className="gall_over"></div>
                </a>
              </div>
              <figcaption className="gallery-title">
                Prayag Completion
              </figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <div className="residency-img">
                <a className="gallary-img" href="/gallery-detail">
                  <Image
                    fill
                    className="image"
                    alt="constrution"
                    src="/images/GangaGhat.png"
                  />
                </a>
              </div>
              <figcaption className="gallery-title">
                Construction Images
              </figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <a
                className="gallary-img newkolkata_launch"
                href="/images/launch/img01.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img02.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img03.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img04.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img05.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img06.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img07.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img08.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img09.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img10.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img11.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img12.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img13.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img14.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img15.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img16.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img17.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img18.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img19.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img20.jpg"
                data-fancybox="launch"
              ></a>
              <a
                className="gallary-img"
                href="/images/launch/img21.jpg"
                data-fancybox="launch"
              ></a>

              <div className="residency-img">
                <span className="plus-icon">
                  <a
                    className="gallary-img"
                    href="/images/launch/img01.jpg"
                    data-fancybox="launch"
                  >
                    <Image
                      fill
                      className="image"
                      alt="plus img"
                      src="/images/zoom_icon.png"
                    />
                  </a>
                </span>
                <a
                  className="gallary-img gall_wrp"
                  href="/images/launch/img01.jpg"
                  data-fancybox="launch"
                >
                  <Image
                    fill
                    className="image img_overlay"
                    alt="prayag"
                    src="/images/launch/img01.jpg"
                  />
                  <div className="gall_over"></div>
                </a>
              </div>
              <figcaption className="gallery-title">
                NEW KOLKATA LAUNCH
              </figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <a
                className="gallary-img ghat_inaugu"
                htmlFor="ghat_inaugu"
                href="/images/green_habitant/Ghat_Inauguration/DJI_0424.JPG"
                data-fancybox="ghat_inaugu"
              ></a>
              <div className="ghat_inaugu_partial">
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0311.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0372.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0394.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0728.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0752.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0757.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0053.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0064.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0065.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0304.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
                <a
                  className="gallary-img"
                  href="/images/green_habitant/Ghat_Inauguration/IMG_0407.jpeg"
                  data-fancybox="ghat_inaugu"
                ></a>
              </div>
              <div className="residency-img">
                <span className="plus-icon">
                  <a
                    className="gallary-img"
                    href="/images/green_habitant/Ghat_Inauguration/DJI_0424.JPG"
                    data-fancybox="ghat_inaugu"
                  >
                    <Image
                      fill
                      className="image"
                      alt="plus img"
                      src="/images/zoom_icon.png"
                    />
                  </a>
                </span>
                <a
                  className="gallary-img gall_wrp"
                  href="/images/green_habitant/Ghat_Inauguration/DJI_0424.JPG"
                  data-fancybox="ghat_inaugu"
                >
                  <Image
                    fill
                    className="image img_overlay"
                    alt="prayag"
                    src="/images/green_habitant/Ghat_Inauguration/DJI_0424.JPG"
                  />
                  <div className="gall_over"></div>
                </a>
              </div>
              <figcaption className="gallery-title">
                Ghat Inauguration
              </figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <div className="residency-img">
                <a className="gallary-img" href="/green-habitants">
                  <Image
                    fill
                    className="image"
                    alt="prayag"
                    src="/images/green_habitant/green-habitant-img.jpg"
                  />
                </a>
              </div>
              <figcaption className="gallery-title">
                Green Habitants images
              </figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <a
                className="gallary-img model_flats"
                htmlFor="model_flats"
                href="/images/modal_flat/Model.png"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0450.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0454.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0459.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0538.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0623.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0630.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0632.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0636.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0648.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0653.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0665.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0673.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0691.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0702.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0703.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0704.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0715.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0721.jpeg"
                data-fancybox="model-flats"
              ></a>
              <a
                className="gallary-img"
                href="/images/modal_flat/IMG_0723.jpeg"
                data-fancybox="model-flats"
              ></a>
              <div className="residency-img">
                <span className="plus-icon">
                  <a
                    className="gallary-img"
                    href="/images/modal_flat/Model.png"
                    data-fancybox="model-flats"
                  >
                    <Image
                      fill
                      className="image"
                      alt="plus img"
                      src="/images/zoom_icon.png"
                    />
                  </a>
                </span>
                <a
                  className="gallary-img gall_wrp"
                  href="/images/modal_flat/Model.png"
                  data-fancybox="model-flats"
                >
                  <Image
                    fill
                    className="image img_overlay"
                    alt="prayag"
                    src="/images/modal_flat/Model.png"
                  />
                  <div className="gall_over"></div>
                </a>
              </div>
              <figcaption className="gallery-title">Model Flats</figcaption>
            </figure>
            <figure className="residency-box gallery-box">
              <a
                className="gallary-img ganga_aarti"
                htmlFor="ganga_aarti"
                href="/images/ganga_aarti/img01.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img02.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img03.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img04.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img05.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img06.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img07.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img08.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img09.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img10.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <a
                className="gallary-img"
                href="/images/ganga_aarti/img11.jpeg"
                data-fancybox="ganga-aarti"
              ></a>
              <div className="residency-img ">
                <span className="plus-icon">
                  <a
                    className="gallary-img"
                    href="/images/ganga_aarti/img01.jpeg"
                    data-fancybox="ganga-aarti"
                  >
                    <Image
                      fill
                      className="image"
                      alt="plus img"
                      src="/images/zoom_icon.png"
                    />
                  </a>
                </span>
                <a
                  className="gallary-img  img_overlay gall_wrp"
                  href="/images/ganga_aarti/img01.jpeg"
                  data-fancybox="ganga-aarti"
                >
                  <Image
                    fill
                    className="image"
                    alt="ganga aarti"
                    src="/images/ganga_aarti/img01.jpeg"
                  />
                  <div className="gall_over"></div>
                </a>
              </div>
              <figcaption className="gallery-title">Ganga Aarti</figcaption>
            </figure>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Gallery;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/gallery?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
